import { module } from 'stereomodularjs';
import modularLoad from '../utils/load';
import { html } from '../utils/environment';

export default class extends module {
	constructor(m) {
		super(m);
	}

	init() {
		window.scrollTo(0, 0);

		// this.linkTarget();

		this.load = new modularLoad({
			enterDelay: 1000
		});


		// On link click
		this.load.on('loading', (transition, oldContainer) => {
			classRemove(document.querySelector('html'), 'is-first-load')
			classRemove(document.querySelectorAll('.has-nav-open'), 'has-nav-open')
			classRemove(document.querySelectorAll('.has-search-open'), 'has-search-open')
			classRemove(document.querySelectorAll('.has-overlay-open'), 'has-overlay-open')
			classAdd(document.querySelector('html'), 'is-changing-page')
			this.currentClass = 't-' + document.querySelector('.js-scroll').getAttribute('data-namespace');

			setTimeout(() => {
				// close all dialogs
				let dialogs = document.querySelectorAll('.js-modal');
				let overlayVideo = document.querySelector('.js-modal-video'); // Sélectionner l'élément overlayVideo
				dialogs.forEach((dialog) => {
					dialog.setAttribute("closing", "");

					dialog.addEventListener(
						"animationend",
						() => {
							dialog.removeAttribute("closing");
							dialog.close();
							overlayVideo.innerHTML = '';
						},
						{ once: true }
					);
				});
			}, 500); // Délai de 1000 millisecondes (1 seconde)
		});

		// On new container enter
		this.load.on('loaded', (transition, oldContainer, newContainer) => {
			classRemove(document.querySelector('body'), this.currentClass)
			this.call('destroy', oldContainer, 'app');
		});

		// On old container exit
		this.load.on('ready', (transition, newContainer) => {
			this.call('update', newContainer, 'app');
			classAdd(document.querySelector('html'), 'is-loaded')
			classRemove(document.querySelector('html'), 'is-changing-page')
			classAdd(document.querySelector('html'), 'dom-is-loaded')
			classAdd(document.querySelector('body'), 't-' + document.querySelector('.js-scroll').getAttribute('data-namespace'))
			// console.log('ADD CLASS CURRENT PAGE : t-' + document.querySelector('.js-scroll').getAttribute('data-namespace'));

			// Reset modal dialogs only — keep PWA overlay .c-modal__item.is-active intact
			document.querySelectorAll('.js-modal .c-modal__item.is-active').forEach((item) => {
				item.classList.remove('is-active');
			});

			const pdfLinks = document.querySelectorAll('a[href$=".pdf"]');
			pdfLinks.forEach(link => {
				link.target = '_blank';
			});
			// this.linkTarget();
		});
	}

	goTo(obj) {
		this.load.goTo(obj.url, obj.transition);
	}

	// linkTarget() {
	// 	// Add target blank to all external links
	// 	let externalLinks = document.querySelectorAll('a[href^="http"]');
	// 	const isExternalURL = (u) => { try { return new URL(u).origin !== location.origin; } catch (e) { return false; } };
	// 	externalLinks.forEach((link) => {
	// 		if (!isExternalURL(link.href)) {
	// 			link.setAttribute('target', '_self');
	// 			link.setAttribute('rel', '');
	// 			return;
	// 		}

	// 		link.setAttribute('target', '_blank');
	// 		link.setAttribute('rel', 'noopener noreferrer');
	// 		var ariaLabel = "Ouvre dans une nouvelle fenêtre";
	// 		if (location.href.match(/\/en\//))
	// 			ariaLabel = "Opens in a new window";
	// 		if (!link.getAttribute('aria-label')) link.setAttribute('aria-label', ariaLabel);
	// 	});

	// 	// Add target blank to all pdf and docx links
	// 	let fileLinks = document.querySelectorAll('a[href$=".pdf"], a[href$=".docx"]');
	// 	fileLinks.forEach((link) => {
	// 		link.setAttribute('target', '_blank');
	// 		var ariaLabel = "Ouvre dans une nouvelle fenêtre";
	// 		if (location.href.match(/\/en\//))
	// 			ariaLabel = "Opens in a new window";
	// 		link.setAttribute('aria-label', ariaLabel);
	// 	});
	// }

	destroy() {
		this.modularLoad.destroy();
	}
}
